import { Link } from "react-router-dom";
import { LogOut, Shield } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { InstallButton } from "@/components/InstallButton";

export const Header = ({ onNew }) => {
  const { user, logout } = useAuth();
  return (
    <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-md border-b rf-line">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10 h-16 flex items-center gap-6">
        <Link to="/" onClick={onNew} className="flex items-center gap-3" data-testid="header-brand-button">
          <span className="w-3.5 h-3.5 bg-[var(--rf-red)]" />
          <span className="font-extrabold tracking-tight">Reverse Frame</span>
        </Link>
        <span className="hidden md:block rf-mono text-[10px] tracking-[0.3em] uppercase text-[var(--rf-grey)]">Analisi visiva / Reverse prompt</span>
        <div className="ml-auto flex items-center gap-3">
          <span className="hidden lg:block text-sm text-[var(--rf-grey)]" data-testid="header-user-email">{user?.email}</span>
          {user?.role === "admin" && (
            <Link to="/admin" className="rf-btn rf-btn-ghost rf-btn-sm" data-testid="header-admin-link">
              <Shield size={14} /> <span className="hidden sm:inline">Admin</span>
            </Link>
          )}
          <InstallButton className="rf-btn-ghost" compact />
          <button onClick={logout} className="rf-btn rf-btn-ghost rf-btn-sm" data-testid="logout-button">
            <LogOut size={14} /> <span className="hidden sm:inline">Esci</span>
          </button>
        </div>
      </div>
    </header>
  );
};
